<template>
    <div class="input-container" :class="label ? 'input-container-with-label' : ''">
        <form-label-title v-if="label" :label="label" :is-required="isRequired" />
        <el-radio-group v-model="value" class="input-radio-group" @change="handleChange($event)">
            <el-radio v-for="(opt, index) in options" :key="'opt' + index" :label="opt.value">
                {{ opt.name }}
            </el-radio>
        </el-radio-group>
    </div>
</template>

<script>
import FormLabelTitle from "./FormLabelTitle";

export default {
    components: {
        "form-label-title": FormLabelTitle,
    },
    props: {
        inputValue: {
            type: String | Number
        },
        label: {
            type: String
        },
        options: {
            type: Array,
            required: true
        },
        isRequired: {
            type: Boolean
        }
    },
    computed: {
        value: {
            set(val) {
                this.$emit("update:inputValue", val);
            },
            get() {
                return this.inputValue;
            }
        }
    },
    methods: {
        handleChange(value) {
            this.$emit("handleChange", value);
        },
    },
};
</script>

<style lang="css">
.input-radio-group .el-radio{
    display: flex;
    margin: 8px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Form/FormRadio.vue